import { Environment } from '.';

/**
 * Attempts to determine the environment of CMX to use.
 * 
 * @returns { string }
 */
export function getCmxEnv( appEnv ) {
    if ( appEnv === Environment.LOCAL || appEnv === Environment.DEV || appEnv === Environment.UNKNOWN ) {
        return Environment.QA;
    } else {
        return appEnv;
    }
}
